import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"
import { t } from "@/lib/i18n"
import { Input } from "@/components/ui/input"

/** Password field with a show/hide toggle — typos in passwords are the most
 * common reason for failed sign-ins and locked-out new employees. */
const PasswordInput = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, ...props }, ref) => {
    const [visible, setVisible] = React.useState(false)
    return (
      <div className="relative flex items-center">
        <Input type={visible ? "text" : "password"} ref={ref} {...props} className={cn("pr-10", className)} />
        <button
          type="button"
          tabIndex={-1}
          aria-label={visible ? t("auth_hide_password") : t("auth_show_password")}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
          className="absolute right-2 grid size-7 place-items-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          {visible ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
        </button>
      </div>
    )
  }
)
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
